import React from 'react';
import { Button } from '../../Button';
import { TTooltipButton } from '../types';
import { Tooltip } from '../../Tooltip';

export const TooltipButton = React.forwardRef((props: TTooltipButton, ref: any) => {
	const {
		icon,
		ariaLabel,
		testId,
		onClickTooltipButton,
	} = props;
	// todo-a11y: improve tooltip positions - default bottom besides for last element (left)
	// todo-a11y: improve tooltip text depending on state: <action> <element>
	// <action>: open/close - switch to
	// <element>: shortcut manager - dark theme/light theme
	return <Tooltip
		content={props.tooltip}
		placement="bottom"
		anchorProps={{ style: { height: '100%', display: 'inline-flex' } }}
	>
		<Button
			ref={ref}
			theme="toggle"
			iconBefore={icon}
			aria-label={ariaLabel}
			data-testid={testId}
			className="p-0 h-100 px-l border-0 rounded-0"
			onClick={onClickTooltipButton}
		/>
	</Tooltip>
});
